exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cockpit-dialog__close[data-v-03f349ac]{background-color:var(--dialogCloseBg);border-radius:3.47px}.cockpit-dialog .dialog-container[data-v-03f349ac]{padding:20px;background-image:var(--dialogBgImg);background-repeat:no-repeat;background-size:100% 100%}", ""]);

// exports
